// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trf-wizard-concluindo[data-v-51da3edc] {\n  min-height: 310px;\n}\n.trf-wizard-splash[data-v-51da3edc] {\n  min-height: 280px;\n}", ""]);
// Exports
module.exports = exports;
